import {HttpExclude, Request, RequestExpose} from '@simpli/serialized-request'
import {PageCollection} from '@simpli/resource-collection'
import {GithubRepositoryUser} from '@/model/resource/GithubRepositoryUser'

@HttpExclude()
export class GithubRepositoryUserCollection extends PageCollection<
  GithubRepositoryUser
> {
  resource?: IGithubRepositoryUserCollectionResourcesHolder

  @RequestExpose() idOrganizationFk: number | null = null
  @RequestExpose() idGithubRepositoryFk: number | null = null

  constructor() {
    super(GithubRepositoryUser)
  }

  queryAsPage() {
    return this.listGithubRepositoryUser()
  }

  async listGithubRepositoryUser() {
    return await Request.get(`/client/github-repository-user`, {
      params: this.params,
    })
      .name('listGithubRepositoryUser')
      .as(this)
      .getResponse()
  }

  async sumContributorsByOrganization(): Promise<number> {
    return await Request.get(
      `/client/github-repository-user/sum-by-organization`,
      {
        params: this.params,
      }
    )
      .name('sumGithubRepositoryUserByOrganization')
      .asNumber()
      .getData()
  }
}

export interface IGithubRepositoryUserCollectionResourcesHolder {}
